import { Button } from '../ui/button';

const SCALES = [
  { id: '1', label: 'A', title: 'Tamaño normal' },
  { id: '1.25', label: 'A+', title: 'Texto más grande (+25%)' },
  { id: '1.5', label: 'A++', title: 'Texto muy grande (+50%)' },
];

const VALID_SCALES = new Set(['1', '1.25', '1.5']);
const LEGACY_SCALE_MAP = { '1.15': '1.25', '1.3': '1.5' };

export function readFontScale() {
  try {
    const v = localStorage.getItem('hcFontScale');
    if (v && VALID_SCALES.has(v)) return v;
    if (v && LEGACY_SCALE_MAP[v]) {
      const migrated = LEGACY_SCALE_MAP[v];
      localStorage.setItem('hcFontScale', migrated);
      return migrated;
    }
  } catch {
    /* ignore */
  }
  return '1';
}

export default function FontScaleToolbar({ scale, onChange }) {
  return (
    <div className="flex items-center gap-1 rounded-full border border-border bg-muted/40 p-1">
      <span className="text-xs text-muted-foreground px-2 hidden sm:inline">Letra</span>
      {SCALES.map((s) => (
        <Button
          key={s.id}
          type="button"
          size="sm"
          variant={scale === s.id ? 'default' : 'ghost'}
          className="h-8 min-w-9 rounded-full px-2"
          title={s.title}
          onClick={() => onChange(s.id)}
        >
          {s.label}
        </Button>
      ))}
    </div>
  );
}
